<template>
  <div>
    <video controls="true" ref="hlsjs_video" id="hlsjs"></video>
  </div>
</template>

<script>
import Hls from "hls.js";

export default {
  props: {
    src: {
      type: String,
      required: true,
    },
    native: {
      // Set to true to prefer native playback
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data: function () {
    return {
      hlsjs: null,
    };
  },
  computed: {
    debug: function () {
      return !!this.$route.query?.debug;
    },
  },
  mounted() {
    if (
      this.native &&
      this.$refs.hlsjs_video.canPlayType("application/vnd.apple.mpegurl")
    ) {
      this.$refs.hlsjs_video.src = this.src;
      return;
    }
    this.hlsjs = new Hls({ debug: this.debug });
    this.hlsjs.loadSource(this.src);
    this.hlsjs.startLoad();
    this.hlsjs.attachMedia(this.$refs.hlsjs_video);
  },
};
</script>

<style lang="scss" scoped>
@import "@/packs/application.scss";

video {
  background-color: black;
}
</style>
